import { Button } from "@/components/ui/button";
import { MainLayout } from "@/components/layout/MainLayout";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <MainLayout>
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
        <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
        <h2 className="text-2xl font-semibold mb-6">عذراً، الصفحة غير موجودة</h2>
        <p className="text-muted-foreground mb-8 max-w-md">
          يبدو أن الصفحة التي تبحث عنها غير موجودة أو تم نقلها إلى مكان آخر
        </p>
        <Link to="/">
          <Button size="lg" className="font-semibold">
            العودة إلى الصفحة الرئيسية
          </Button>
        </Link>
      </div>
    </MainLayout>
  );
};

export default NotFound;